<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class="mb-1 background_color" >
              <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Product Sales </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" >Invoice</a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/sinvoice/index"> Manage Invoice </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>{{ alldata.invoice_num }} </h6>

            <div class="container-fluid">
                <!-- <h6 class="custom-maintitle mb-1"><b>{{ products.P_code }}  </b></h6> -->




                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
       

                  

                  <button  @click="Confimmodel()" v-if="alldata.status==1"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Confirm</button>
                  <button  @click="Createreceipt()" v-if="alldata.status==3"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad">  Create Receipt</button>
                

                <button  @click="Update()" v-if="alldata.status==1"   class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Update</button>
                <button @click="sendDataToSandbox()" :disabled="isSendingSandbox" class="btn btn-sm btn-outline-primary mb-1 bdr-rad">
                  {{ isSendingSandbox ? 'Sending...' : 'e Invoice' }}
                </button>
                <button v-if="alldata.status!=1"  @click="generatePDF()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Print</button>
                 
            
                </div>
              
                <div v-if="sandboxSendResult" class="row mt-2 justify-content-end">
                  <div class="col-12">
                    <div
                      class="alert"
                      :class="sandboxSendResult.status === 200 ? 'alert-success' : 'alert-danger'"
                      style="font-size: small;"
                    >
                      <div><b>Last Sandbox Send:</b> {{ sandboxSendResult.message }}</div>
                      <div v-if="sandboxSendResult.sandbox_url"><b>URL:</b> {{ sandboxSendResult.sandbox_url }}</div>
                      <div v-if="sandboxSendResult.recipient"><b>Recipient:</b> {{ sandboxSendResult.recipient }}</div>
                      <div v-if="sandboxSendResult.payload_summary"><b>Payload:</b> {{ JSON.stringify(sandboxSendResult.payload_summary) }}</div>
                      <div v-if="sandboxSendResult.error_details"><b>Details:</b> {{ JSON.stringify(sandboxSendResult.error_details) }}</div>
                    </div>
                  </div>
                </div>

                <div class="card custom_bdr_rds shadow p-2" v-if="isLoading">
                  <div class="card-body custom_bdr_rds">

                <div class="d-flex justify-content-center" >
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>

                  </div>
                </div>

                <div v-else class="mt-1">
                <div >



                <div class="card custom_bdr_rds shadow p-2">
                <div  class="card-body custom_bdr_rds">


                    <table style="font-size: small; " class="table table-hover  table-sm table-borderless  ">
       
                        <tbody >
                 
                         
                          <tr>
                            <td class="width-custom2"><b>Invoice Number</b></td>
                           <td>{{ alldata.invoice_num }}</td> 
                          </tr>
                          <tr>
                            <td><b>Sales Order Number</b></td>
                           <td>{{ alldata.relatedToSo.so_code }}</td> 
                          </tr>
                          <tr>
                            <td><b>Invoice Type</b></td>
                           <td>{{ alldata.invoice_type }}</td> 
                          </tr>
                         
                          <tr>
                            <td><b>Customer</b></td>
                           <td>{{ alldata.relatedToCustomer.C_name }}</td> 
                          </tr>
                          <tr>
                            <td><b>Delivery Address </b></td>
                           <td>{{ alldata.relatedToCustomerAdd.address_line_1 }}{{ alldata.relatedToCustomerAdd.address_line_2 }}{{ alldata.relatedToCustomerAdd.address_line_3 }}</td> 
                          </tr>
                          <tr>
                            <td><b>Subtotal (Rs) </b></td>
                           <td>{{ alldata.total_invoice_amt }}</td> 
                          </tr>
                        
                          <tr>
                            <td><b>Special Discount  {{ alldata.discount_percentage }}%</b></td>
                           <td>{{ alldata.discount_amount }}</td> 
                          </tr>
                          <tr>
                            <td><b>Total After 0.00% </b></td>
                           <td>{{ alldata.total_chargeable_cost }}</td> 
                          </tr>
                          <tr>
                            <td><b>Total Chargeable Value (Rs) </b></td>
                           <td>{{ alldata.total_chargeable_cost }}</td> 
                          </tr>
                          <tr>
                            <td><b>Paid Amount (Rs) </b></td>
                           <td>{{ sinvo.amt }}</td> 
                          </tr>
                          <tr>
                            <td><b>Total Payable Amount (Rs) </b></td>
                           <td>{{ sinvo.bal }}</td> 
                          </tr>
                         
                          <tr>
                            <td><b>Status</b></td>
                           <td>{{ alldata.relatedToStatus.status }}</td> 
                          </tr>
                          <tr>
                            <td><b>Sales Person Name</b></td>
                           <td>{{ alldata.relatedToSalesPerson.name }}</td> 
                          </tr>
                          <tr>
                            <td><b>Remarks</b></td>
                           <td>{{ alldata.inv_remarks }}</td> 
                          </tr>
                          <tr>
                            <td><b>Created Date</b></td>
                           <td>{{ alldata.created_date }}</td> 
                          </tr>


                          <tr>
                            <td><b>Quotation Code</b></td>
                           <td>{{ all_code.qu_code }}</td> 
                          </tr>
                         
                          <tr>
                            <td><b> SO Code</b></td>
                            <td>{{ all_code.so_code }}</td> 
                          </tr>
                          <tr>
                            <td><b>GIN</b></td>
                            <td>{{ all_code.SI_issueNum }}</td> 
                          </tr>
                          <tr>
                            <td><b>Receipt Number</b></td>
                            <td>{{ all_code.rec }}</td> 
                          </tr>
                          
                         
                           
                        </tbody>
                 
                 
                      </table>

                </div>
                </div>



                      <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                          <h6 class="purchitem mb-2"><b>Added Products</b></h6>

                         <div class="table-responsive"> 
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2">
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>Product</th>
                              <th>Product Description</th>
                              <th class="text_right">Price (Rs)</th>
                              <th class="text_right">New Price (Rs)</th>
                              <th class="text_right">Qty	</th>
                              <th class="text_right">Discount</th>
                              <th class="text_right">Line Amount (Rs)</th>
                            
                              </tr>
                            </thead>
                            <tbody>
                              <tr  v-for="(detail, index) in details" :key="detail.id">
                              <td>{{ index+1 }}</td>
                              <td>{{ detail.p_code }}</td>
                              <td >{{detail.P_description}}</td>
                              <td class="text_right">{{detail.price}}</td>
                              <td class="text_right">{{detail.new_price}}</td>
                              <td class="text_right">{{detail.qty}}</td>
                              <td class="text_right">{{detail.discount}}%</td>
                              <td class="text_right">{{detail.line_amount}}</td>
                              
                              </tr>
                              <tr style="border-top: 2px solid black; " >
                              <td></td>
                            
                              <td></td>
                              <th>Total :</th>
                              <td class="text_right"></td>
                              <td></td>
                              <th class="text_right">{{ total.total_qty }}</th>
                              <th class="text_right"></th>
                              <th class="text_right">{{ total.total_line_amount }}</th>
                            
                              </tr>
                              <tr  >
                              <td></td>
                            
                              <td></td>
                              <th>Special Discount :</th>
                              <td></td>
                              <td></td>
                              <th class="text_right"></th>
                              <th class="text_right"></th>
                              <th class="text_right">{{ total.discount_amount }}</th>
                            
                              </tr>
                              <tr  >
                              <td></td>
                             
                              <td></td>
                              <th>Total :</th>
                              <td></td>
                              <td></td>
                              <th class="text_right"></th>
                              <th class="text_right"></th>
                              <th class="text_right">{{ total.sub_total }}</th>
                            
                              </tr>
                            </tbody>

                          </table>

</div>
                        </div>
                    </div>



                    <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Received Advanced Payments</b></h6>

                           
                         <div class="table-responsive">  
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2">
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>Receipt No</th>
                              <th>Receipt Date</th>
                              <th>Paid Amount (Rs)</th>
                           
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(rec_det, index) in rec_dets" :key="rec_det.id">
                              <td>{{ index + 1 }}</td>
                              <td>{{ rec_det.receipt_num }}</td>
                              <td>{{ rec_det.receipt_date }}</td>
                              <td>{{ rec_det.paid_amount }}</td>
                             
                              </tr>
                            </tbody>

                          </table>

</div>
                        </div>
                    </div>






                    <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Audit Trail</b></h6>

                            
                         <div class="table-responsive"> 
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2">
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>Field Name</th>
                              <th>Comment</th>
                              <th>Action</th>
                              <th>Created Date</th>
                              <th>Created Time</th>
                              <th>Created By</th>
                              <th>Previous Value</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr >
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              </tr>
                            </tbody>

                          </table>
</div>

                        </div>
                    </div>



                    <div class="card custom_bdr_rds shadow p-2">
              <div class="card-body custom_bdr_rds">
                  <h6 class="purchitem mb-2"><b>CRM Notes</b></h6>

                         <div class="table-responsive"> 
                  
                  <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                  <thead class="background_color2">
                    <tr class="custom-label2">
                    <th>#</th>
                    <th>Comment</th>
                    <th>Job Type</th>
                    <th>Created Date</th>
                    <th>Created By</th>
                    <th>Follow up Date	</th>
                    <th>Follow up by	</th>
                   
                    
                    </tr>
                  </thead>
                  <tbody>
                    <tr  v-for="(mservicelog, index) in mservicelogs" :key="mservicelog.idServicelog">
                    <td>{{index+1}}</td>
                    <td>{{ mservicelog.comments }}</td>
                    <td>{{ mservicelog.job_type }}</td>
                    <td>{{ mservicelog.created_date }}</td>
                    <td>{{ mservicelog.relatedToUser.username }}</td>
                    <td>{{ mservicelog.followup_date }}</td>
                    <td>{{ mservicelog.relatedToFollowupby.username }}</td>
                  
                    
                    </tr>
                  </tbody>

                </table>
</div>

          <br>
              

                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Comments </label>
                            <textarea rows="3" v-model="crm.comments"  style="font-size: small;" class="form-control" ></textarea>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Job Type</label>
                            <select class="form-select" v-model="crm.job_type">
                              <option  selected>Select....</option>
                              <option >Vehicle Sales</option>
                              <option  >Spare Parts Sales</option>
                            </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Follow up Date</label>
                            <input v-model="crm.followup_date" type="date"  style="font-size: small;" class="form-control" >
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Follow up By</label>
                            <input v-model="username"  style="font-size: small;" class="form-control" disabled>
                    </div>
                  </div>


                </div>
           
                <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
                <div class="d-flex  ">
                
                </div>
                <div class="d-flex  ">
                    <button @click="crmCreate()"  class="mr-1 btn btn-outline-primary btn-sm  mb-0 mt-0 font-size_def bdr-rad">Save</button>
                </div>
                </div>

            </div>
        </div>







   

<br><br>





                




                </div>
                </div>
              </div>
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
        import jsPDF from 'jspdf';
   import 'jspdf-autotable';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadSinvoice()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            'id':this.$route.query.id,
            username:authService.isUsername(),
            total:{},
            alldata:{},
            category:{},
            brand:{},
            supplier:{},
            status:{},
            user:{},
            crm:{},
            mservicelogs:[],
            sinvo:{},
            all_code:{},
            details:[],
            trans:[],
            rec_dets:[],
            sandboxRecipient: '',
            isSendingSandbox: false,
            sandboxSendResult: null,
     
           
          }
    
        },
        components :{
         
            ContentFooter,
            TopNavbar,
           
        },

        methods : {

          generatePDF() {
    const pdfWindow = window.open('', '_blank');
    if (pdfWindow) {
      // pdfWindow.document.write('<p style="font-family: Arial, sans-serif; padding: 16px;">Preparing invoice PDF...</p>');
    }
    const safeText = value => (value === null || value === undefined) ? '' : String(value);
    
    const doc = new jsPDF();

    function addPageBorders(doc) {
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;

  // Set the border style
  doc.setDrawColor(71, 144, 255); // Black color
  doc.setLineWidth(15); // Border width

  // Draw a line at the top of the page
  doc.line(0, 0, pageWidth, 0);
  // Draw a line at the bottom of the page
  doc.line(0, pageHeight, pageWidth, pageHeight);
}
   // Update this with your image URL or file path
 
    var img = new Image()
  img.src = '/img/evenware-logo.jpg'
  img.onload = () => {
  const customer = this.alldata.relatedToCustomer || {};
  const salesPerson = this.alldata.relatedToSalesPerson || {};
  const salesOrder = this.alldata.relatedToSo || {};
  const imageWidth = doc.internal.pageSize.getWidth() - 550; // Adjust 20 if you need margins
const imageHeight = (imageWidth * 3) / 4; // Assuming the aspect ratio is 4:3, adjust as needed

doc.addImage(img, 'png', 10, 13, imageWidth, imageHeight);
doc.setFontSize(18);
doc.setFont('Helvetica', 'bold');
doc.text('INVOICE', 105, 30, null, null, 'center');
doc.setFontSize(12);

doc.text('Demonstration System', 10, 45, null, null);

doc.setFont('Helvetica', 'normal');
doc.setFontSize(8);
doc.text('819, North South Road,', 10, 48, null, null);
doc.text('Westwood Central,', 10, 51, null, null);
doc.text('Billingsgate.', 10, 54, null, null);



doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('Invoice To:', 85, 45, null, null);
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(safeText(customer.C_name), 85, 48, null, null);
doc.text(safeText(customer.C_address_line2), 85, 51, null, null);
doc.text(safeText(customer.C_address_line3), 85, 54, null, null);








doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('Invoice Number:', 200, 45, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(safeText(this.alldata.invoice_num), 200, 49, null, null, 'right');



doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('GIN No:', 200, 53, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(safeText(this.all_code.SI_issueNum), 200, 56, null, null, 'right');

doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('Sales Person:', 200, 60, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(safeText(salesPerson.name), 200, 63, null, null, 'right');

doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('Payment Terms:', 200, 67, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(safeText(salesOrder.payment_method), 200, 70, null, null, 'right');




doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('Date:', 200, 74, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(safeText(this.alldata.invoiced_date), 200, 77, null, null, 'right');

const tableData = [
      ['No', 'Product Code', 'Product Description', 'Price', 'Qty', 'Discount %', 'Line Amount']
  ];
  

  this.details.forEach(detail => {
      tableData.push([
          detail.no,
          detail.p_code,
          detail.P_description,
          { content: detail.price, styles: { halign: 'right' } },
          { content: detail.qty, styles: { halign: 'right' } },
          { content: detail.discount, styles: { halign: 'right' } },
         
       
          { content: detail.line_amount, styles: { halign: 'right' } },
         
         
        
      ]);
  });

      // Add table to the PDF
      doc.autoTable({
            startY: 85, // Y position to start the table
            head: [tableData[0]], // Table header
            body: tableData.slice(1),
            addPageContent: function(data) {
        addPageBorders(doc); // Call the function to add page borders
    },
    styles: {
        font: 'Helvetica',
        fontSize:8,
    },
          // Table data excluding header
      });

      
      const tableBottomY = doc.lastAutoTable.finalY;

      doc.setFontSize(10);
      doc.setFont('Helvetica', 'bold');
      doc.text('Sub Total: '+this.total.total_line_amount, 195, tableBottomY+10, null, null, 'right');

      doc.setFontSize(10);
      doc.setFont('Helvetica', 'bold');
      doc.text('Special Discount: '+this.total.discount_amount, 195, tableBottomY+18, null, null, 'right');

      doc.setFontSize(10);
      doc.setFont('Helvetica', 'bold');
      doc.text('Total :'+this.total.sub_total, 195, tableBottomY+26, null, null, 'right');

      doc.setFontSize(9);
        doc.setFont('Helvetica', 'normal');
    
      



      const blob = doc.output('blob');
    const url = URL.createObjectURL(blob);
    if (pdfWindow) {
      pdfWindow.location.href = url;
    } else {
      doc.save((this.alldata.invoice_num || 'invoice') + '.pdf');
    }
  };
  img.onerror = () => {
    if (pdfWindow) {
      pdfWindow.close();
    }
    doc.save((this.alldata.invoice_num || 'invoice') + '.pdf');
  };

  },
    
          
      async Update(){
        this.$router.push('/ssalesorder/update?id='+this.id);
      },

      async sendDataToSandbox() {
        if (this.isSendingSandbox) {
          return;
        }

        this.isSendingSandbox = true;

        try {
          const payload = {
            invoice_number: this.alldata.invoice_num || '',
            customer_name: (this.alldata.relatedToCustomer && this.alldata.relatedToCustomer.C_name) ? this.alldata.relatedToCustomer.C_name : '',
            item_count: Array.isArray(this.details) ? this.details.length : 0,
            subtotal: this.alldata.total_invoice_amt || '0.00',
            total_chargeable_amount: this.alldata.total_chargeable_cost || '0.00'
          };

          const { data } = await axios.post('/sinvoice/sendtosandbox?id=' + this.id, payload, {
            headers: {
              'Authorization': 'Bearer ' + this.access_token,
              'Content-type': 'application/json',
            }
          });

          this.sandboxSendResult = data;

          if (data && data.status === 200) {
            window.alert(
              'Payload sent to Peppol sandbox successfully.\n' +
              'Recipient: ' + (data.recipient || this.sandboxRecipient) + '\n' +
              'Invoice: ' + payload.invoice_number
            );
          } else {
            let message = (data && data.message) ? data.message : 'Unable to send invoice data to sandbox.';
            if (data && data.error_details) {
              message += '\nDetails: ' + JSON.stringify(data.error_details);
            } else if (data && data.error) {
              message += '\nDetails: ' + data.error;
            }
            window.alert(message);
          }
        } catch (error) {
          let message = 'Request failed.';
          if (error && error.response && error.response.data) {
            const responseData = error.response.data;
            this.sandboxSendResult = responseData;
            if (typeof responseData === 'object') {
              message = responseData.message || responseData.error || message;
              if (responseData.error_details) {
                message += '\nDetails: ' + JSON.stringify(responseData.error_details);
              }
              if (responseData.payload_summary) {
                message += '\nPayload: ' + JSON.stringify(responseData.payload_summary);
              }
            } else {
              message = responseData || message;
            }
          } else if (error && error.message) {
            message = error.message;
            this.sandboxSendResult = {
              status: 500,
              message: error.message
            };
          }
          window.alert('Sandbox send failed: ' + message);
        } finally {
          this.isSendingSandbox = false;
        }
      },


      async crmCreate() {
       
    
       try {
         const { data} = await  axios.post('/sinvoice/crmcreate?id='+this.id,{crm:this.crm,userid:this.userid},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
            this.loadSinvoice();
           
          
        }
         
       } catch (error) {
         console.log(error.response);
       }
     },




            async loadSinvoice() {
        console.log("Amila");
      
      try {
        const { data} = await  axios.get('/sinvoice/view?id='+this.id,{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
          this.alldata = data.alldata
          this.all_code = data.all_code
          this.sinvo = data.sinvoice
           this.details = data.details
          this.total = data.total
          this.rec_dets = data.rec_dets
          this.mservicelogs = data.mservicelogs
          this.sandboxSendResult = null
       
        
      } catch (error) {
        console.log(error.response);
      }
    },

  

        

  

    },
    
    }
    
    </script>

    <style scoped>
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */

.button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;
 
 
  
  cursor: pointer;
}

.button-link:hover {
  color: black;
  text-decoration: underline;
}
    </style>
